import { ArdoqId } from '@ardoq/api-types';
import { dispatchAction } from '@ardoq/rxbeach';
import { selectComponent } from 'streams/components/ComponentActions';

const navigateToComponent = (cid: ArdoqId) =>
  dispatchAction(selectComponent({ cid }));
export { navigateToComponent };
